import type { JSX, PropsWithChildren } from 'react';
import { styled } from 'styled-components';
import { Stack } from '../Stack';

const Container = styled.div`
  padding: var(--wui-space-02);
`;

export type ColorPickerSectionProps = PropsWithChildren;

/**
 * A padded section for grouping related controls within a
 * `ColorPickerPopoverContent`. Provides consistent spacing between sections.
 */
export const ColorPickerSection = ({ children }: ColorPickerSectionProps): JSX.Element => {
  return (
    <Container>
      <Stack>{children}</Stack>
    </Container>
  );
};

ColorPickerSection.displayName = 'ColorPickerSection';
